import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function getDashboardData(data) {
  let apiUrl = `${apiBasePath}/dashboard`;

  const params = [];

  if (data?.bootcampIds?.length) {
    params.push(`bootcampIds=${data.bootcampIds.join(",")}`);
  }
  if (data?.formId?.length) {
    params.push(`formId=${data.formId.join(",")}`);
  }
  if (data?.phase) {
    params.push(`phase=${data.phase}`);
  }

  if (data?.competencyId) {
    params.push(`competencyId=${data.competencyId}`);
  }

  if (data?.asSpoc !== undefined) {
    params.push(`asSpoc=${data.asSpoc}`);
  }

  if (data?.asHr !== undefined) {
    params.push(`asHr=${data.asHr}`);
  }

  if (data?.asAttendee !== undefined) {
    params.push(`asAttendee=${data.asAttendee}`);
  }

  if (data?.asMentor !== undefined) {
    params.push(`asMentor=${data.asMentor}`);
  }

  if (data?.paginated !== undefined) {
    params.push(`paginated=${data.paginated}`);
  }

  if (params.length) {
    apiUrl += `?${params.join("&")}`;
  }

  return ApiService({
    method: "GET",
    url: apiUrl,
  });
}


export function getBootCampAndFormList() {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/filtersForDashBoard`
  })
}

export function getDashboardConfig() {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/configuration/metrics`
  })
}
